export const SHOW_SPINNER = "@@SPINNER/SHOW_SPINNER";
export const HIDE_SPINNER = "@@SPINNER/HIDE_SPINNER";

export const actionCreators = {
  showSpinner: () => ({
    type: SHOW_SPINNER,
  }),
  hideSpinner: () => ({
    type: HIDE_SPINNER,
  }),
};
